import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LayoutDashboard, Users, Radio, LogOut } from "lucide-react";

export function AdminLayout({ children }) {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  const link = ({ isActive }) =>
    `flex items-center gap-3 px-4 py-3 text-sm font-medium rounded-sm transition-colors ${
      isActive ? "bg-[#0090A8]/10 text-[#0090A8] border border-[#0090A8]/30" : "text-gray-500 hover:text-[#0A0A0A] border border-transparent hover:bg-black/5"
    }`;

  return (
    <div className="min-h-screen flex bg-white text-[#0A0A0A]">
      <aside className="w-64 border-r border-[#E4E4E7] bg-[#FAFAFA] flex flex-col p-4 sticky top-0 h-screen">
        <div className="flex items-center gap-2 px-2 py-4 mb-4">
          <Radio className="text-[#0090A8]" size={22} />
          <div>
            <div className="font-display font-black tracking-tight leading-none">WEBINARHUB</div>
            <div className="overline mt-1">Admin Console</div>
          </div>
        </div>
        <nav className="flex flex-col gap-2 flex-1">
          <NavLink to="/admin" end className={link} data-testid="admin-nav-dashboard">
            <LayoutDashboard size={18} /> Dashboard
          </NavLink>
          <NavLink to="/admin/employees" className={link} data-testid="admin-nav-employees">
            <Users size={18} /> Employees
          </NavLink>
          <NavLink to="/admin/webinars" className={link} data-testid="admin-nav-webinars">
            <Radio size={18} /> Webinars
          </NavLink>
        </nav>
        <div className="border-t border-[#E4E4E7] pt-4">
          <div className="px-2 mb-3">
            <div className="text-sm font-semibold truncate">{user?.name}</div>
            <div className="text-xs text-gray-500 truncate">{user?.email}</div>
          </div>
          <button
            onClick={() => { logout(); nav("/login"); }}
            data-testid="admin-logout"
            className="flex items-center gap-2 w-full px-4 py-2.5 text-sm text-gray-500 hover:text-[#D92D20] transition-colors"
          >
            <LogOut size={16} /> Logout
          </button>
        </div>
      </aside>
      <main className="flex-1 overflow-x-hidden">{children}</main>
    </div>
  );
}
